// @flow
import * as React from 'react'
import {translate} from 'react-i18next'
import {
  Banner,
  Link
} from 'tutellus-ui'

import {Page} from './Page'

export const NotFound = translate('notfound')(({t}) =>
  <Page>
    <Banner title={t('title')} background_url={t('background_url')}>
      <p>{t('description')}</p>
      <Link button primary href='/'>{t('goback')}</Link>
    </Banner>
  </Page>
)



// WEBPACK FOOTER //
// ./src/pages/NotFound.js